
import { Component, Mixins, Watch } from "vue-property-decorator";
import {
  Size,
} from "../../../../../domain/drawing";
import { NewObjectLocatableMixin } from ".";

@Component
export default class NewObjectStampableMixin extends Mixins(NewObjectLocatableMixin) {
  data(): any {
    return {
      stampSize: new Size(20, 20) as Size,
    };
  }
  stampSize: Size;

  @Watch("stampSize")
  onNewObjectStamperStampSizeUpdated(newValue: Size, oldValue: Size) {
    this.updateStamp();
  }

  private updateStamp(): void {
    const shouldStamp = !!this.stampSize;
    if (this.editingSource) {
      this.writeProperty(s => s.geometry.rectangle.size = shouldStamp ? this.stampSize : new Size(0, 0));
    }
    this.process = shouldStamp
    ? this.locate
    : () => this.layoutRectangle(20, 20);
  }

  created(): void {
    this.updateStamp();
  }
}
